import React, { FC, ReactNode, useEffect, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import columns from "../../models/ColumnDefinitions/PresetControllerColumns";
import { ListQuery } from "../../models/ListQuery";
import { Lookup } from "../../models/Lookup";
import LookupTypes from "../../models/LookupTypes";
import searchColumns from '../../models/search/PresetControllerSearch';
import SiteSearch from "../../models/search/SiteSearch";
import { getSiteNamesWithPagination } from "../../services/siteService";
import TableTab from "../tabs/table-tab";
import { PRESET_TYPES } from "../../constants/preset-constants";
import { getDevicesPerPresetType } from "../../services/hardwarePresetService";

interface Props {
    itemId: string,
    children?: ReactNode;
}

const PresetControllers: FC<Props> = ({ itemId,children }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.assignedControllers);
    const [lookup, setLookup] = useState<Lookup[]>([]);

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            }]);
        })();
    }, []);

    return <TableContextProvider
        dataMethod={(listParameters?: ListQuery) => getDevicesPerPresetType(itemId, PRESET_TYPES.CONTROLLER, listParameters)}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useTable
        usePagination
        useSearch
        useSort
        useFilter
        lookup={lookup}>
        <TableTab
            title={title}
            selectRows={false}
            cyName="controllerPresets"
        >
            {children}
        </TableTab>
    </TableContextProvider>
};

export default PresetControllers;
